import { render, staticRenderFns } from "./createarticle.vue?vue&type=template&id=cc0cb686"
import script from "./createarticle.vue?vue&type=script&lang=js"
export * from "./createarticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports